import { Button, Typography, Wrapper } from '@screentone/core';

import { useStructureEditContext } from 'contexts/structure-edit/StructureEditContext';
import { Layout } from 'data/generated/graphql';
import styles from './LayoutHeader.module.scss';

interface LayoutHeaderProps {
  layout: Layout;
}

export const LayoutHeader = ({ layout }: LayoutHeaderProps) => {
  const { isPublishing, handlePublish } = useStructureEditContext();

  return (
    <Wrapper padding={{ top: 'md', bottom: 'md' }} className={styles.headerWrapper}>
      <div className={styles.headerLeft}>
        <Typography variant="header2" margin={{ bottom: 'none' }} data-testid="layout-name">
          {layout.name}
        </Typography>
      </div>
      <div className={styles.headerRight}>
        <Button primary onClick={handlePublish} disabled={isPublishing} data-testid="layout-publish-button">
          {isPublishing ? 'Publishing...' : 'Publish'}
        </Button>
      </div>
    </Wrapper>
  );
};
